// extracted by mini-css-extract-plugin
export var billingAddress = "_xz-g";
export var contactInfo = "_xz-d";
export var customerInfoContainer = "_xz-c";
export var customerInfoContainerMobile = "_xz-h";
export var customerInfoRow = "_xz-a";
export var customerInfoSection = "_xz-b";
export var fullWidthDividerMobile = "_xz-i";
export var imageContainer = "_xz-1";
export var paymentMethod = "_xz-e";
export var priceText = "_xz-6";
export var priceTextMobile = "_xz-7";
export var product = "_xz-0";
export var productImage = "_xz-2";
export var productInfo = "_xz-4";
export var productMobile = "_xz-9";
export var productTitle = "_xz-8";
export var quantityBadge = "_xz-3";
export var quantityText = "_xz-5";
export var shippingAddress = "_xz-f";